class ProductAddons extends HTMLElement {
  constructor() {
    super();
    this.isAdding = false; // Prevent double-clicks
  }

  connectedCallback() {
    this.querySelectorAll('.pdp-rec-add-btn').forEach((button) => {
      button.addEventListener('click', this.handleAddToCart.bind(this));
    });
  }

  async handleAddToCart(event) {
    const button = event.currentTarget;
    const variantId = button.getAttribute('data-variant-id');

    if (!variantId) return;

    // Prevent rapid double-clicks
    if (this.isAdding) return;
    this.isAdding = true;

    button.disabled = true;
    button.classList.add('loading');

    // Open cart drawer
    document.dispatchEvent(new CustomEvent('opencart', { bubbles: true }));

    try {
      // Use CartRequestManager queue if available
      if (window.CartRequestManager) {
        await window.CartRequestManager.queueRequest(async () => {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          });

          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }

          window.CartRequestManager.invalidateCache();
        });
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
      }

      // Update cart - try multiple event names for compatibility
      document.dispatchEvent(new CustomEvent('updateCart', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart-update', { bubbles: true }));

      // Also try publishing via pubsub if available
      if (typeof publish === 'function') {
        publish('cart-update', {});
      }
    } catch (error) {
      console.error('Error adding product to cart:', error);
    } finally {
      button.disabled = false;
      button.classList.remove('loading');
      // Allow new clicks after a delay
      setTimeout(() => {
        this.isAdding = false;
      }, 500);
    }
  }
}

customElements.define('product-addons', ProductAddons);
